require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-dom-testing-library.json") })
        }
      }, "path---package-bs-dom-testing-library");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-dom-testing-library!./.cache/json/package-bs-dom-testing-library.json
// module id = 774
// module chunks = 231608221292675